import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "src/components/ui/button";
import { Card, CardContent } from "src/components/ui/card";
import { Badge } from "src/components/ui/badge";
import { Skeleton } from "src/components/ui/skeleton";

const C_BTN_LANDING = {
  Max: "#1677ff",
  Telegram: "#0088cc",
  SMS: "#52c41a",
};

const QrPublicLanding = () => {
  const { code } = useParams();
  const [page, setPage] = useState(null);
  const [visitId, setVisitId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!code) return;
    const init = async () => {
      try {
        const pageRes = await axios.get(`/api/qr/p/${code}`);
        setPage(pageRes.data.page);
        const visitRes = await axios.post(`/api/qr/visit/${code}`);
        setVisitId(visitRes.data.visit_id);
      } catch (err) {
        console.error("QR landing error:", err);
        setError("Страница не найдена");
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [code]);

  const handleButtonClick = async (btnType) => {
    if (!visitId) return;
    try {
      await axios.post(`/api/qr/target/${visitId}`, { button_type: btnType, registered: true });
      if (btnType === "Max") window.location.href = "https://max.ru/register";
      else if (btnType === "Telegram") window.location.href = "https://t.me/your_bot";
      else if (btnType === "SMS") alert("Введите номер телефона (демо)");
    } catch (err) {
      console.error("Target tracking error:", err);
    }
  };

  const isSVG = (s) => typeof s === "string" && s.trim().startsWith("<svg");

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4">
        <Card className="w-full max-w-sm">
          <CardContent className="pt-6 space-y-3">
            <Skeleton className="h-10 w-10 rounded-full mx-auto" />
            <Skeleton className="h-32 w-full rounded-lg" />
            <Skeleton className="h-6 w-3/4 mx-auto" />
            <Skeleton className="h-4 w-2/3 mx-auto" />
            <div className="flex gap-2 justify-center">
              <Skeleton className="h-9 w-24 rounded-md" />
              <Skeleton className="h-9 w-24 rounded-md" />
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4">
        <Card className="w-full max-w-sm">
          <CardContent className="pt-8 pb-8 text-center space-y-2">
            <p className="text-sm text-red-500">Ошибка</p>
            <p className="text-muted-foreground text-sm">{error || "Страница не найдена"}</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-muted/30">
      <Card className="w-full max-w-sm shadow-sm">
        <CardContent className="pt-8 pb-6 flex flex-col items-center gap-4 text-center">
          {page.logo &&
            (isSVG(page.logo) ? (
              <div dangerouslySetInnerHTML={{ __html: page.logo }} className="h-10 mx-auto" />
            ) : (
              <div className="text-4xl">{page.logo}</div>
            ))}

          {page.image_url &&
            (isSVG(page.image_url) ? (
              <div
                dangerouslySetInnerHTML={{ __html: page.image_url }}
                className="w-full max-h-32 overflow-hidden rounded-lg"
              />
            ) : (
              <img
                src={page.image_url}
                alt="cover"
                className="w-full max-h-36 object-cover rounded-lg"
                onError={(e) => (e.currentTarget.style.display = "none")}
              />
            ))}

          <div className="space-y-1">
            <h1 className="text-xl">{page.name}</h1>
            {page.description && (
              <p className="text-sm text-muted-foreground">{page.description}</p>
            )}
          </div>

          <div className="flex flex-wrap gap-2 justify-center w-full pt-1">
            {(page.buttons || []).map((btn) => (
              <Button
                key={btn.type}
                onClick={() => handleButtonClick(btn.type)}
                style={{ backgroundColor: C_BTN_LANDING[btn.type] || "#1677ff" }}
                className="text-white hover:opacity-90 transition-opacity"
              >
                {btn.label}
              </Button>
            ))}
          </div>

          {page.auto_tags?.length > 0 && (
            <div className="flex flex-wrap gap-1 justify-center">
              {page.auto_tags.map((tag) => (
                <Badge key={tag} variant="secondary" className="text-xs">
                  {tag}
                </Badge>
              ))}
            </div>
          )}

          <p className="text-xs text-muted-foreground pt-2">qrrun.ru/{page.short_code}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default QrPublicLanding;